export const images = {
  phoneBorder: require("./cell_preview3x.png"),
  statusBar: require("./img_statusbar3x.png"),
};
